import { Spinner } from "phosphor-react"
import { useRef, useState } from "react"
import { VerificationLink } from "~/__generated__/graphql"
import { EVENT_IDS, EVENTS } from "~/common/analytics"
import { trackEvent } from "~/common/analytics"
import { downloadPath } from "~/common/paths"
import { PhoneNumberValue } from "~/common/phone-number"
import {
  GENERATE_VERIFICATION_LINK_MUTATION,
  handlePhoneSubmission,
} from "~/common/phone-submission"
import { useSafeMutation } from "~/common/use-safe-mutation"
import { Link } from "~/ui/link"
import { PhoneNumberInput } from "~/ui/phone-number/phone-number-input"
import { useToast } from "~/ui/use-toast"
import { useRecaptcha } from "~/hooks/use-recaptcha"

const TRACKING_DATA = {
  unique_id: EVENT_IDS.GET_APP_CLICKED,
}

export function GetTheAppDesktop() {
  const [phoneValue, setPhoneValue] = useState<PhoneNumberValue>({
    number: "",
    callingCode: "1",
    countryCode: "US",
    flag: "US",
  })
  const phoneInputRef = useRef<HTMLInputElement>(null)
  const [generateVerificationLink, { loading }] = useSafeMutation(
    GENERATE_VERIFICATION_LINK_MUTATION
  )
  const { toast } = useToast()
  const { verifyRecaptcha } = useRecaptcha()

  const phoneInputEnabled = () => {
    if (!phoneInputRef.current) return false
    return true
  }

  const handlePhoneChange = (value: PhoneNumberValue) => {
    setPhoneValue(value)
    if (value.number.replace(/\D/g, "").length >= 10) {
      trackEvent(EVENTS.PHONE_NUMBER_ENTERED, {
        phone_number_last_4: value.number.replace(/\D/g, "").slice(-4),
      })
    }
  }

  const handleGetAppClick = async () => {
    const recaptchaToken = await verifyRecaptcha()

    await handlePhoneSubmission({
      phoneValue,
      setPhoneValue,
      verificationLinkType: VerificationLink.DownloadApp,
      recaptchaToken,
      trackingData: TRACKING_DATA,
      toast,
      generateVerificationLink,
      successMessage: "Texting you a link to download the app.",
    })

    if (!phoneInputEnabled()) {
      trackEvent(EVENTS.ITEM_PRESSED, {
        ...TRACKING_DATA,
        success: true,
      })
      window.location.href = downloadPath({})
      return
    }
  }

  return (
    <div className="hidden h-20 w-full flex-row pt-8 md:flex">
      <div className="flex flex-row">
        <PhoneNumberInput
          ref={phoneInputRef}
          value={phoneValue}
          onChange={handlePhoneChange}
          onSubmit={handleGetAppClick}
          className="pr-4"
          inputClassName="rounded-xs min-w-60"
        />
        <Link
          to={phoneInputEnabled() ? "#" : downloadPath({})}
          onClick={(e) => {
            e.preventDefault()
            handleGetAppClick()
          }}
        >
          <button className="flex h-12 w-full min-w-[180px] items-center justify-center rounded-full border border-base-black bg-support-yellow py-3">
            <div className="font-md-nichrome text-18 font-medium leading-8 text-base-black">
              {loading ? <Spinner className="animate-spin" /> : "GET THE APP"}
            </div>
          </button>
        </Link>
      </div>
    </div>
  )
}
